import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject,of } from 'rxjs';
import referralsJson from '../assets/referrals.json';
import legacyPromoJson from '../assets/foodPandaPromo.json';
import {
   aeonbank,
   airbnb,
   anw,
   asnb,
   atlas,
   atome,
   baskinRobin,
   beam,
   beutea,
   bhg,
   bhp,
   bigpay,
   boost,
   boostBank,
   breadtalk,
   bungkuskawkaw,
   caltexgo,
   cashzine,
   chagee,
   crypto,
   cultbeauty,
   dash,
   easybook,
   enrichMoney,
   fave,
   fastgig,
   foneApp,
   foodpanda,
   funcrush,
   fundrama,
   funflip,
   getbats,
   googlePay,
   guardian,
   gxbank,
   hata,
   hoshinoCoffee,
   hotTomato,
   innisfree,
   jag,
   kdi,
   kmiles,
   krisplus,
   lendlease,
   lookfantastic,
   luckin,
   luno,
   mglobal,
   milkadeal,
   moomoo,
   myprotein,
   novelah,
   octafx,
   paragonClub,
   parisBaguette,
   petron,
   rewardLand,
   rollti,
   ryde,
   rytBank,
   secretrecipe,
   setel,
   shell,
   shopback,
   shopee,
   shopfareast,
   socash,
   storymorph,
   suntecplus,
   tigerTrade,
   time,
   tripcom,
   trustBank,
   versa,
   wahed,
   watsons,
   westMall,
   youtrip,
   zcity,
   zus
} from './constant';


export interface ReferralData {
   title: string;
   category: string;
   url: string;
   info: string;
   logo: string;
   signup: string;
   index: string;
   dateAdded:number,
   tutorial:any[];
   isValid:string;
}

export interface BirthdayData {
   title: string;
   category: string;
   info: string;
   referral:boolean;
   link:string;
   referraldesc:string;
   imagelink:string;
}


@Injectable({
   providedIn: 'root'
})
export class DataService {
   private url = "/assets/referrals.json"
   private promoUrl = "/assets/promos.json"
   private data: any[] = [];
   private birthdayData: ReferralData[]=[]
   private promo: any;
   private currentPage: number;
   private showPage = false;
   private baseUrl = "/";
   private sortBy = "alpha";
   private messageSource = new BehaviorSubject('default message');
   public currentMessage = this.messageSource.asObservable();
   private searchSource = new BehaviorSubject('');
   public currentSearch = this.searchSource.asObservable();
   private sortedList: string[] = [
      "aeonbank",
      "airbnb",
      "anw",
      "asnb",
      "atlas",
      "atome",
      "baskinrobbins",
      "beam",
      "beutea",
      "bhg",
      "bhpetrol",
      "bigpay", 
      "boost", 
      "breadtalk",
      "bungkuskawkaw",
      "caltexgo",
      "cashzine", 
      "chagee",
      "crypto",
      "cultbeauty",
      "dash", 
      "easybook",
      "enrichmoney",
      "fave", 
      "fastgig",
      "funcrush",
      "fundrama",
      "funflip",
      "googlepay",
      "guardian",
      "gxbank",
      "hata",
      "hoshino",
      "hottomato",
      "innisfree",
      "jag", 
      "kdi",
      "kmiles",
      "krisplus",
      "lendlease",
      "lookfantastic",
      "luckin",
      "luno",
      "mglobal",
      "milkadeal",
      "moomoo",
      "myprotein",
      "novelah",
      "octafx",
      "paragonclub",
      "parisbaguette",
      "petron",
      "rewardland",
      "rollti",
      "ryde",
      "rytbank",
      "secretrecipe",
      "setel", 
      "shell",
      "shopback", 
      "shopee",
      "shopfareast",
      "storymorph",
      "suntecplus",
      "tigertrade",
      "tripcom",
      "trustbank",
      "versa",
      "wahed",
      "watsons",
      "westmall",
      "youtrip",
      "zcity",
      "zus"]
   constructor(private httpClient: HttpClient) {
      // this.httpClient.get(this.url).subscribe((data: any) => {
      //    this.data = data.data;
      // });
      

      const constantData = [
         aeonbank, airbnb, anw, asnb, atlas, atome, baskinRobin, beam, beutea, bhg, bhp, bigpay, boost, boostBank,
         breadtalk, bungkuskawkaw, caltexgo, cashzine, chagee, crypto, cultbeauty, dash, easybook, enrichMoney, fave, fastgig, foneApp,
         foodpanda, funcrush, fundrama, funflip, getbats, googlePay, guardian, gxbank, hata, hoshinoCoffee,
         hotTomato, innisfree, jag, kdi, kmiles, krisplus, lendlease, lookfantastic, luckin, luno, mglobal, milkadeal,
         moomoo, myprotein, novelah, octafx, paragonClub, parisBaguette, petron, rewardLand, rollti, ryde, rytBank,
         secretrecipe, setel, shell, shopback, shopee, shopfareast, socash, storymorph, suntecplus, tigerTrade,
         time, tripcom, trustBank, versa, wahed, watsons, westMall, youtrip, zcity, zus
      ];
      const legacyRouteIndexByUrl = new Map<string, string>([
         ['8excite-referral-code', '8excite'],
         ['eatigo-referral-code', 'eatigo'],
         ['ezdiscount-invitation-code', 'ezdiscount'],
         ['fingo-invitation-code', 'fingo'],
         ['forestone-referral-code', 'forestone'],
         ['hellogold-promo-code', 'hellogold'],
         ['lazada-invitation-code', 'lazada'],
         ['quandoo-promo-code', 'quandoo'],
         ['razerpay-referral-code', 'razerpay'],
         ['rebatemango-referral-program', 'rebatemango'],
         ['swypeon-promo-code', 'swypeon'],
         ['whyq-referral-code', 'whyq']
      ]);
      const manualLegacyData: ReferralData[] = [
         {
            title: '8excite',
            category: 'others,my',
            url: '8excite-referral-code',
            info: 'Sign up with 8excite referral code : UQYXFT4 to get 100 8excite points for free!',
            logo: 'assets/8excite-referral.jpg',
            signup: 'https://play.google.com/store/apps/details?id=com.excite8.app',
            index: '8excite',
            dateAdded: 1567588740,
            tutorial: ['assets/tutorial/8excite-referral-code.jpg', 'assets/tutorial/8excite-register-step1.PNG', 'assets/tutorial/8excite-register-step2.PNG'],
            isValid: ''
         },
         {
            title: 'Lazada Invitation Code',
            category: 'shopping,my',
            url: 'lazada-invitation-code',
            info: 'Sign up with Lazada invitation code: 3TTKJLXO to get new-user vouchers.',
            logo: 'assets/lazada-invitation-code.png',
            signup: 'https://c.lazada.com.my/t/c.1MmWyM',
            index: 'lazada',
            dateAdded: 1567588740,
            tutorial: ['assets/tutorial/lazada-invitation-code-step1.png', 'assets/tutorial/lazada-invitation-code-step2.png', 'assets/tutorial/lazada-invitation-code.png'],
            isValid: 'N'
         }
      ];
      const mergedByIndex = new Map<string, ReferralData>();
      const jsonData = (referralsJson as { data: ReferralData[] }).data || [];
      const legacyJsonData = ((legacyPromoJson as { data: Partial<ReferralData>[] }).data || [])
         .map(referral => ({
            ...referral,
            index: referral.index || legacyRouteIndexByUrl.get(referral.url || ''),
            tutorial: referral.tutorial || [],
            isValid: referral.isValid || ''
         } as ReferralData))
         .filter(referral => referral.index);

      jsonData.forEach(referral => {
         if (referral.index && !mergedByIndex.has(referral.index)) {
            mergedByIndex.set(referral.index, referral);
         }
      });
      legacyJsonData.forEach(referral => {
         if (referral.index && !mergedByIndex.has(referral.index)) {
            mergedByIndex.set(referral.index, referral);
         }
      });
      manualLegacyData.forEach(referral => mergedByIndex.set(referral.index, referral));
      constantData.forEach(referral => mergedByIndex.set(referral.index, referral));

      this.data = Array.from(mergedByIndex.values());
      this.sortedList = [
         ...this.sortedList,
         ...this.data.map(referral => referral.index).filter(index => index && !this.sortedList.includes(index))
      ];
   }

   getBaseUrl(): string {
      return this.baseUrl;
   }


   setData(data) {
      this.data = data;
   }

   setBirthdayData(data){
      this.birthdayData = data;
   }

   setNum(num) {
      this.currentPage = num;
   }

   getPromo():Observable<any>{
      if(this.promo == undefined){
         return this.httpClient.get(this.promoUrl);
      }else{
         return of(this.promo);
      }
   }

   setPromo(promos:any){
      this.promo = promos;
   }


   getReadyPromo():any[]{
      return this.promo;
   }

   getIndex(app:string){
      return this.sortedList.indexOf(app);
   }

   getNum(): number {
      return this.currentPage;
   }

   getData(num) {
      const appIndex = this.sortedList[num];
      if (appIndex) {
         const app = this.data.find(entry => entry.index === appIndex);
         if (app) {
            return app;
         }
      }
      return this.data[num];
   }

   getAllData(): readonly ReferralData[] {
      return this.data;
   }


   setSort(sort:string){
      this.sortBy = sort;
      this.messageSource.next(sort)
   }

   getSort(){
      return this.sortBy;
   }

   setSearch(searchText:string){
      this.searchSource.next(searchText || '');
   }

   getSearch(){
      return this.searchSource.value;
   }

   getShowPage(): boolean {
      return this.showPage;
   }

   setShowPage(showPage: boolean) {
      this.showPage = showPage;
   }

   getPage(url:string){
      this.data.forEach(a=>{
         if(a.url.includes(url)){
            return a;
         }
      })
   }
}
